import { ModalMessageComponent } from './../../../../shared/modais/modal-message/modal-message.component';
import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { DadoSimulacao } from './../model/dado-simulacao';
import { PropostaSimulacao } from './../model/proposta/proposta-simulacao';
import { Parcela, ParcelaFlexivel } from '../parcela/parcela';
import { TipoPagamentoEnum } from '../../../../produtos/shared/enums/tipo-pagamrnto.enum';
import { ParametroParcela } from '../../../../services/parametro-parcela/parametro-parcela.interface';

@Component({
  selector: 'parcela-flexivel',
  templateUrl: './parcela-flexivel.component.html',
  styleUrls: ['./parcela-flexivel.component.css']
})
export class ParcelaFlexivelComponent implements OnChanges {

  @Input() proposta: PropostaSimulacao;
  @Input() simulacao: DadoSimulacao;
  @Input() parcelasSimuladas: Parcela[] = [];
  @Input() parametros: ParametroParcela;

  @Output() simular: EventEmitter<boolean> = new EventEmitter();
  @Output() parcelaSelecionadaChange = new EventEmitter<boolean>();

  @ViewChild('modalMessage', { static: true }) modalMessage: ModalMessageComponent;

  parcelaSelecionada: Parcela | ParcelaFlexivel | null = null;
  parcelaSelecionadaMensal: Parcela | null = null;
  parcelaSelecionadaFlexivel: ParcelaFlexivel | null = null;
  tipoPagamento = '';
  dataCarenciaMinima?: number;
  dataCarenciaMaxima?: number;
  private manterSelecaoAposRecalculo = false;
  changePrimeiraParcela = true;
  private ultimaSelecao: {
    tipo: string;
    quantidade?: number;
    periodicidade?: number;
    primeiraParcela?: any;
  } | null = null;
  
  ngOnChanges(changes: SimpleChanges) {
    const dataMantida =
      this.ultimaSelecao?.primeiraParcela ||
      this.simulacao?.primeiraParcela ||
      (this.proposta as any)?.primeiraParcelaSelecionada ||
      localStorage.getItem('primeiraParcelaSelecionada');

    const quantidadeMantida =
      this.ultimaSelecao?.quantidade ||
      (this.parcelaSelecionada && this.getQuantidade(this.parcelaSelecionada)) ||
      (this.parcelaSelecionadaFlexivel && this.getQuantidade(this.parcelaSelecionadaFlexivel));

    const tipoAnterior =
      this.ultimaSelecao?.tipo ||
      this.tipoPagamento ||
      (this.parametros?.monthly === 'S' ? 'mensal' : 'flexivel');

    if (this.parametros && this.parametros.monthly !== 'S' && this.exibirParcelasFlexiveis) {
      this.tipoPagamento = 'flexivel';
    } else if (this.parametros?.monthly === 'S') {
      this.tipoPagamento = 'mensal';
      this.simulacao.setPrimeiraParcelaFlexivel(1);
    }
    if (changes['parcelasSimuladas'] && this.parcelasSimuladas?.length) {
       this.definirParcelaSelecionada();

      if (this.parcelaSelecionada) {
        this.dataCarenciaMinima = (this.parcelaSelecionada as any).dataCarenciaMinima;
        this.dataCarenciaMaxima = (this.parcelaSelecionada as any).dataCarenciaMaxima;

        const taxaCliente = this.safeGetTaxaCliente();
        const precisaAtualizar =
          !taxaCliente ||
          taxaCliente.periodicidadePagamento == null ||
          taxaCliente.prazoMeses == null ||
          taxaCliente.taxaNormalizada == null ||
          taxaCliente.parcelas !== this.getQuantidade(this.parcelaSelecionada);

        if (precisaAtualizar) {
          const taxaFinal = this.getTaxaFinalFromParcela(this.parcelaSelecionada);
          this.onSelectParcelaFlexivel(this.parcelaSelecionada as Parcela, taxaFinal);
        } else {
          this.parcelaSelecionadaChange.emit(false);
        }
      } else {
        this.parcelaSelecionadaChange.emit(false);
      }

      queueMicrotask(() => {
        if (tipoAnterior === 'flexivel' && this.exibirParcelasFlexiveis) {
          const todasFlex = this.parcelasSimuladas.flatMap(p => p.parcelasFlexiveis || []);
          if (todasFlex.length) {
            const parcelaAnterior =
              todasFlex.find(p => this.getQuantidade(p) === quantidadeMantida) ||
              todasFlex[todasFlex.length - 1];

            this.parcelaSelecionadaFlexivel = parcelaAnterior;
            this.parcelaSelecionada = parcelaAnterior;
            this.tipoPagamento = 'flexivel';
            this.onSelectParcelaFlexivel(parcelaAnterior, parcelaAnterior.taxa);
          }
        } else if (tipoAnterior === 'mensal') {
          const todasMensais = this.parcelasSimuladas.filter(
            p => p.periodicidadePagamento === 1
          );
          if (todasMensais.length) {
            const parcelaAnterior =
              todasMensais.find(p => this.getQuantidade(p) === quantidadeMantida) ||
              todasMensais[todasMensais.length - 1];

            this.parcelaSelecionadaMensal = parcelaAnterior;
            this.parcelaSelecionada = parcelaAnterior;
            this.tipoPagamento = 'mensal';

            const taxaFinal = this.getTaxaFinalFromParcela(parcelaAnterior);
            this.onSelectParcelaFlexivel(parcelaAnterior, taxaFinal);
          }
        }

        if (dataMantida) {
          if (this.simulacao?.setPrimeiraParcela) {
            this.simulacao.setPrimeiraParcela(dataMantida);
          }

          (this.simulacao as any).primeiraParcela = dataMantida;
          (this.proposta as any).primeiraParcelaSelecionada = dataMantida;
          localStorage.setItem('primeiraParcelaSelecionada', dataMantida);
        }

        this.manterSelecaoAposRecalculo = false;
        this.changePrimeiraParcela = true;
      });
    }
   
  }

  private reaplicarUltimaSelecao(): boolean {
    if (!this.ultimaSelecao || !this.parcelasSimuladas?.length) return false;

    const { tipo, quantidade, periodicidade, primeiraParcela } = this.ultimaSelecao;

    if (this.simulacao) {
      if (typeof this.simulacao.setPrimeiraParcela === 'function' && primeiraParcela) {
        this.simulacao.setPrimeiraParcela(primeiraParcela);
      }
      (this.simulacao as any).primeiraParcelaSelecionada = primeiraParcela;
    }

    if (tipo === 'mensal') {
      const encontrada = this.parcelasSimuladas.find(p => this.getQuantidade(p) === quantidade);
      if (encontrada) {
        this.parcelaSelecionadaMensal = encontrada;
        this.parcelaSelecionada = encontrada;
        const taxaFinal = this.getTaxaFinalFromParcela(encontrada);
        this.onSelectParcelaFlexivel(encontrada, taxaFinal);
        this.tipoPagamento = 'mensal';
        return true;
      }
    } else if (tipo === 'flexivel') {
      const todasFlex = this.parcelasSimuladas.flatMap(p => p.parcelasFlexiveis || []);
      const encontradaFlex = todasFlex.find(
        f => this.getQuantidade(f) === quantidade && f.periodicidadePagamento === periodicidade
      );
      if (encontradaFlex) {
        this.parcelaSelecionadaFlexivel = encontradaFlex;
        this.parcelaSelecionada = encontradaFlex;
        const taxaFinal = this.getTaxaFinalFromParcela(encontradaFlex);
        this.onSelectParcelaFlexivel(encontradaFlex, taxaFinal);

        if (primeiraParcela) {
          if (this.simulacao && typeof this.simulacao.setPrimeiraParcela === 'function') {
            this.simulacao.setPrimeiraParcela(primeiraParcela);
          } else if (this.simulacao) {
            (this.simulacao as any).primeiraParcelaSelecionada = primeiraParcela;
          }
        }

        this.tipoPagamento = 'flexivel';
        return true;
      }
    }

    return false;
  }

  private safeGetTaxaCliente(): any {
    if (!this.proposta) return null;
    try {
      return this.proposta.getTaxaClinte ? this.proposta.getTaxaClinte() : (this.proposta as any).taxaCliente;
    } catch {
      return (this.proposta as any).taxaCliente ?? null;
    }
  }

  private getQuantidade(p: any): number {
    return p?.parcelas ?? p?.quantidade ?? p?.getQuantidade?.() ?? 0;
  }

  private getTaxaFinalFromParcela(parcela: any): number {
    return parcela?.getTaxa?.() ?? parcela?.taxa ?? parcela?.taxaFinal ?? 0;
  }

  onSelectParcelaFlexivel(parcela: Parcela | ParcelaFlexivel, taxaFinal: number) {
    const quantidade = (parcela as any).quantidade ?? (parcela as any).getQuantidade?.();
    const periodicidade =
      (parcela as any).periodicidadePagamento ?? (parcela as any).getPeriodicidadePagamento?.();
    const valor = (parcela as any).valor ?? (parcela as any).getValor?.();
    const fator = (parcela as any).fator ?? (parcela as any).getFator?.();
    const valorTotal = (parcela as any).valorTotal ?? (parcela as any).getValorTotal?.();
    const prazoMeses = (parcela as any).prazoMeses ?? (parcela as any).getPrazoMeses?.();
    const taxa = (parcela as any).taxa ?? (parcela as any).getTaxa?.();

    this.parcelaSelecionada = parcela;

    const dataAtual =
      this.ultimaSelecao?.primeiraParcela ||
      (this.simulacao as any)?.primeiraParcela ||
      (this.proposta as any)?.primeiraParcelaSelecionada;

    if (this.simulacao) {
      const periodicidadeAnterior = this.parcelaSelecionadaFlexivel.periodicidadePagamento?? null;

      if (typeof this.simulacao.setParcelas === 'function') {
        this.simulacao.setParcelas(quantidade);
      }

      if (typeof this.simulacao.setPeriodicidadePagamento === 'function') {
        this.simulacao.setPeriodicidadePagamento(periodicidade);
      }

      if (dataAtual && typeof this.simulacao.setPrimeiraParcela === 'function') {
        this.simulacao.setPrimeiraParcela(dataAtual);
      }

      (this.simulacao as any).primeiraParcela = dataAtual;

      if (typeof this.simulacao.setPrimeiraParcelaFlexivel === 'function') {
        this.simulacao.setPrimeiraParcelaFlexivel(periodicidade);
      }

    }

    const taxaClinte = this.proposta.getTaxaClinte();
    taxaClinte.valorParcela = valor;
    taxaClinte.parcelas = quantidade;
    taxaClinte.fator = fator;
    taxaClinte.valorLiberado = valorTotal;
    taxaClinte.periodicidadePagamento = periodicidade;
    if(this.changePrimeiraParcela){
        if(this.tipoPagamento === 'flexivel'){
          taxaClinte.taxaFinal = this.parcelaSelecionadaMensal.getTaxa();
          taxaClinte.taxaNormalizada = taxa;
        if(this.parcelaSelecionada.taxa !==  taxaFinal &&  taxaClinte.taxaFinal !== taxaFinal){
          taxaClinte.taxaFinal = taxaFinal;
        }
      }else{
        taxaClinte.taxaFinal = taxaFinal;
      }
    }
    if(this.tipoPagamento === 'flexivel'){
          taxaClinte.prazoMeses = prazoMeses;
    }
   
    taxaClinte.tipoPagamento =
      periodicidade === 1 ? TipoPagamentoEnum.MENSAL : TipoPagamentoEnum.FLEXIVEL;

    if (dataAtual) {
      (this.proposta as any).primeiraParcelaSelecionada = dataAtual;
    }

    this.dataCarenciaMinima = (parcela as any).dataCarenciaMinima;
    this.dataCarenciaMaxima = (parcela as any).dataCarenciaMaxima;
    this.parcelaSelecionadaChange.emit(true);
  }

  onChangePrimeiraParcela(data: any) {
    this.simulacao.setPrimeiraParcela(data);
    this.changePrimeiraParcela = false;
    this.simular.emit(true);
  }

  get exibirParcelasFlexiveis(): boolean {
    const p = this.parametros;
    if (!p) return false;
    const parametrosValidos = !(p.weekly === 'N' && p.decennial === 'N' && p.biweekly === 'N');
    const parcelasValidas =
      this.parcelasSimuladas &&
      this.parcelasSimuladas.some(
        parcela => parcela.parcelasFlexiveis && parcela.parcelasFlexiveis.length > 0
      );
    return parametrosValidos || parcelasValidas;
  }

  onChangeTipoPagamento(tipoPagamento: string): void {
    this.tipoPagamento = tipoPagamento;
    if (tipoPagamento === 'flexivel' && this.parcelaSelecionadaFlexivel) {
      this.parcelaSelecionada = this.parcelaSelecionadaFlexivel;
      this.onSelectParcelaFlexivel(this.parcelaSelecionadaFlexivel, this.proposta.getTaxaClinte().taxaFinal || 0);
      this.simulacao.setPrimeiraParcelaFlexivel(this.parcelaSelecionadaFlexivel.periodicidadePagamento);
      this.changePrimeiraParcela = true;
      this.onChangePrimeiraParcela(this.simulacao.primeiraParcela)
    } else if (tipoPagamento === 'mensal' && this.parcelaSelecionadaMensal) {
      this.parcelaSelecionada = this.parcelaSelecionadaMensal;
      this.onSelectParcelaFlexivel(this.parcelaSelecionadaMensal, this.proposta.getTaxaClinte().taxaFinal || 0);
      this.simulacao.setPrimeiraParcelaFlexivel(this.parcelaSelecionadaMensal.periodicidadePagamento);
      this.changePrimeiraParcela = true;
      this.onChangePrimeiraParcela(this.simulacao.primeiraParcela)
    } else {
      this.simulacao.setPrimeiraParcelaFlexivel && this.simulacao.setPrimeiraParcelaFlexivel(1);
    }
    this.parcelaSelecionadaChange.emit(true);
  }

  definirParcelaSelecionada(): void {
    if (!this.parcelasSimuladas?.length) return;

    this.parcelaSelecionadaFlexivel = null;
    this.parcelaSelecionadaMensal = null;
    this.parcelaSelecionada = null;

    const todasFlexiveis = this.parcelasSimuladas
      .filter(p => Array.isArray(p.parcelasFlexiveis) && p.parcelasFlexiveis.length > 0)
      .flatMap(p => (p.parcelasFlexiveis || []).map(f => ({ flex: f, parent: p })));

    const prioridade = [7, 10, 14];
    let encontradaFlex: { flex: ParcelaFlexivel; parent: Parcela } | undefined;

    for (const per of prioridade) {
      encontradaFlex = todasFlexiveis.find(
        x => x.flex.periodicidadePagamento === per && (x.flex as any).exibir !== false
      );
      if (encontradaFlex) break;
    }

    if (encontradaFlex) {
      const mesmaPeriodicidade = todasFlexiveis
        .filter(
          x =>
            x.flex.periodicidadePagamento === encontradaFlex!.flex.periodicidadePagamento &&
            (x.flex as any).exibir !== false
        )
        .sort((a, b) => {
          const parcelasA = a.flex.parcelas ?? (a.flex as any).quantidade ?? 0;
          const parcelasB = b.flex.parcelas ?? (b.flex as any).quantidade ?? 0;
          return parcelasB - parcelasA;
        });

      if (mesmaPeriodicidade.length) {
        this.parcelaSelecionadaFlexivel = mesmaPeriodicidade[0].flex;
      }
    }

    const mensais = this.parcelasSimuladas
      .filter(p => p.periodicidadePagamento === 1 && (p as any).exibir !== false)
      .sort((a, b) => {
        const parcelasA = (a as any).quantidade ?? (a as any).parcelas ?? 0;
        const parcelasB = (b as any).quantidade ?? (b as any).parcelas ?? 0;
        return parcelasB - parcelasA;
      });

    if (mensais.length) {
      this.parcelaSelecionadaMensal = mensais[0];
    }

    this.parcelaSelecionada =
      this.parcelaSelecionadaMensal ?? this.parcelaSelecionadaFlexivel ?? null;
  }
}
